/** Dataset flow names eligible for script generation. */
export const SCRIPT_GENERATION_FLOW_NAMES = new Set(["Topics", "Angles"])

/** Dataset the script-generation gate dialog suggests switching to. Stays "Topics"
 *  independently of the preselected filter flow (DEFAULT_OPPORTUNITY_FLOW_NAME). */
export const SCRIPT_GENERATION_FLOW_NAME = "Topics" as const

export function isScriptGenerationEligible(flowName: string): boolean {
  return SCRIPT_GENERATION_FLOW_NAMES.has(flowName)
}

export interface ScriptGenerationSelectionPartition {
  eligibleIds: string[]
  ineligibleIds: string[]
  /** Distinct non-eligible dataset names among ineligible rows. */
  ineligibleFlowNames: string[]
  /** Selected IDs not present in the loaded opportunity list (e.g. not yet fetched). */
  unknownIds: string[]
}

export function partitionScriptGenerationSelection(
  opportunities: ReadonlyArray<{ id: string; flowName: string }>,
  selectedIds: readonly string[],
): ScriptGenerationSelectionPartition {
  const byId = new Map(opportunities.map((o) => [o.id, o]))
  const eligibleIds: string[] = []
  const ineligibleIds: string[] = []
  const ineligibleFlows = new Set<string>()
  const unknownIds: string[] = []

  for (const id of selectedIds) {
    const opp = byId.get(id)
    if (!opp) {
      unknownIds.push(id)
      continue
    }
    if (isScriptGenerationEligible(opp.flowName)) {
      eligibleIds.push(id)
    } else {
      ineligibleIds.push(id)
      ineligibleFlows.add(opp.flowName)
    }
  }

  return {
    eligibleIds,
    ineligibleIds,
    ineligibleFlowNames: [...ineligibleFlows],
    unknownIds,
  }
}

/** When the table is filtered to an eligible dataset, every loaded row is eligible. */
export function isScriptGenerationFilterActive(flowName: string): boolean {
  return SCRIPT_GENERATION_FLOW_NAMES.has(flowName)
}
